<template>
  <div class="pc-head" :class="{ 'not-home': notHome }">
    <div class="content flex-center-stright">
      <div class="logo-box">
        <!-- <img src="../../assets/img/computer/logo.png" class="logo" v-if="!notHome" /> -->
        <img src="../../assets/img/computer/logo.svg" class="logo" />
        <!-- <div class="back flex-center" @click="link()">
          <i class="iconfont iconfanhuijiuban" style="margin-right:5px"></i>
          返回旧版
        </div>-->
      </div>
      <pc-nav :notHome="notHome"></pc-nav>
      <pc-search v-if="notHome"></pc-search>
    </div>
  </div>
</template>
<script>
import PcSearch from "./Search";
import PcNav from "./Nav";
export default {
  props: ["notHome"],
  components: {
    PcNav,
    PcSearch,
  },
  data() {
    return {
      routeList: ["/", "/token"],
    };
  },
  computed: {
    routerPath() {
      return this.$route.path;
    },
  },
  methods: {
    link() {
      window.open("https://oldmainnet.bityuan.com");
    },
  },
};
</script>

<style lang="scss">
.pc-head {
  height: 70px;
  min-width: 1250px;
  background: $home_head;
  .logo-box {
    display: inline-flex;
    .logo {
      height: 35px;
    }
  }
  .back {
    margin-left: 40px;
    width: 106px;
    height: 30px;
    background: rgba(255, 255, 255, 1);
    border-radius: 19px;
    color: #2675ba;
    cursor: pointer;
  }
  .content {
    position: relative;
    width: 1250px;
    height: 100%;
    padding: 0 25px;
    margin: 0 auto;
    .head-nav {
      position: absolute;
      height: 70px;
      width: 650px;
      top: 0;
      right: 0;
      color: $white;
      font-size: 14px;
      font-weight: 500;
      font-family: PingFangSC-Medium;
    }
  }
}
.not-home {
  background: $white;
  height: 120px;
  box-shadow: 0px 2px 4px 0px rgba(231, 238, 244, 1);
  .back {
    margin-top: 28px;
    background: rgba(99, 104, 222, 1);
    color: #fff;
  }
  .content {
    display: block;
    .logo {
      margin: 28px 0 0 12px;
    }
    .head-nav {
      top: 55px;
      left: 0;
      bottom: 0;
      color: $black;
    }
  }
}

// 动画区
</style>
